import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `AWSDateTime` scalar type provided by AWS AppSync, represents a valid ***extended*** [ISO 8601 DateTime](https://en.wikipedia.org/wiki/ISO_8601#Combined_date_and_time_representations) string. In other words, this scalar type accepts datetime strings of the form `YYYY-MM-DDThh:mm:ss.SSSZ`.  The scalar can also accept "negative years" of the form `-YYYY` which correspond to years before `0000`. For example, "**-2017-01-01T00:00Z**" and "**-9999-01-01T00:00Z**" are both valid datetime strings.  The field after the two digit seconds field is a nanoseconds field. It can accept between 1 and 9 digits. So, for example, "**1970-01-01T12:00:00.2Z**", "**1970-01-01T12:00:00.277Z**" and "**1970-01-01T12:00:00.123456789Z**" are all valid datetime strings.  The seconds and nanoseconds fields are optional (the seconds field must be specified if the nanoseconds field is to be used).  The [time zone offset](https://en.wikipedia.org/wiki/ISO_8601#Time_zone_designators) is compulsory for this scalar. The time zone offset must either be `Z` (representing the UTC time zone) or be in the format `±hh:mm:ss`. The seconds field in the timezone offset will be considered valid even though it is not part of the ISO 8601 standard. */
  AWSDateTime: any;
  /** The `AWSURL` scalar type provided by AWS AppSync, represents a valid URL string (Ex: <https://www.amazon.com/>). The URL may use any scheme and may also be a local URL (Ex: <http://localhost/>).  URLs without schemes like "**amazon.com**" or "**www.amazon.com**" are considered invalid. URLs which contain double slashes (two consecutive forward slashes) in their path are also considered invalid. */
  AWSURL: any;
};












export type CreateFavoriteInput = {
  context: Scalars['String'];
  name: Scalars['String'];
  data: GlobalFilterInput;
  url: Scalars['AWSURL'];
};

export type CreateFilterGroupInput = {
  context: Scalars['String'];
  name: Scalars['String'];
  data: GlobalFilterInput;
};

export type Favorite = {
  __typename?: 'Favorite';
  id: Scalars['ID'];
  context: Scalars['String'];
  name: Scalars['String'];
  client?: Maybe<Scalars['String']>;
  data: GlobalFilter;
  url?: Maybe<Scalars['AWSURL']>;
  created?: Maybe<Scalars['AWSDateTime']>;
  updated?: Maybe<Scalars['AWSDateTime']>;
  deleted?: Maybe<Scalars['Boolean']>;
};

export type FilterGroup = {
  __typename?: 'FilterGroup';
  id: Scalars['ID'];
  context: Scalars['String'];
  name: Scalars['String'];
  data: GlobalFilter;
  created?: Maybe<Scalars['AWSDateTime']>;
  updated?: Maybe<Scalars['AWSDateTime']>;
};

export type GlobalFilter = {
  __typename?: 'GlobalFilter';
  weeks?: Maybe<Scalars['Int']>;
  endWeek?: Maybe<Scalars['String']>;
  accounts?: Maybe<Array<Maybe<Scalars['String']>>>;
  items?: Maybe<Array<Maybe<Scalars['String']>>>;
  stores?: Maybe<Array<Maybe<Scalars['String']>>>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  brand?: Maybe<Scalars['String']>;
};

export type GlobalFilterInput = {
  weeks?: Maybe<Scalars['Int']>;
  endWeek?: Maybe<Scalars['String']>;
  accounts?: Maybe<Array<Maybe<Scalars['String']>>>;
  items?: Maybe<Array<Maybe<Scalars['String']>>>;
  stores?: Maybe<Array<Maybe<Scalars['String']>>>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  brand?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createFilterGroup?: Maybe<FilterGroup>;
  createFavorite?: Maybe<Favorite>;
  updateFilterGroup?: Maybe<FilterGroup>;
  deleteFavorite?: Maybe<Favorite>;
  deleteFilterGroup?: Maybe<FilterGroup>;
};


export type MutationCreateFilterGroupArgs = {
  client: Scalars['String'];
  input: CreateFilterGroupInput;
};


export type MutationCreateFavoriteArgs = {
  client: Scalars['String'];
  input: CreateFavoriteInput;
};


export type MutationUpdateFilterGroupArgs = {
  id: Scalars['ID'];
  client: Scalars['String'];
  input: CreateFilterGroupInput;
};


export type MutationDeleteFavoriteArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFilterGroupArgs = {
  id: Scalars['ID'];
};

export type PageableInput = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  fetchFilterGroups?: Maybe<Array<Maybe<FilterGroup>>>;
  fetchFilterGroup?: Maybe<FilterGroup>;
  fetchFavorites?: Maybe<Array<Maybe<Favorite>>>;
  fetchFavorite?: Maybe<Favorite>;
};


export type QueryFetchFilterGroupsArgs = {
  client: Scalars['String'];
  brand?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  pageable?: Maybe<PageableInput>;
  sorting?: Maybe<SortingInput>;
};


export type QueryFetchFilterGroupArgs = {
  context?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type QueryFetchFavoritesArgs = {
  client: Scalars['String'];
  brand?: Maybe<Scalars['String']>;
};


export type QueryFetchFavoriteArgs = {
  id: Scalars['ID'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortingInput = {
  sortedBy: SortParameter;
  sortDirection: SortDirection;
};

export enum SortParameter {
  Name = 'name',
  Created = 'created',
  Accounts = 'accounts',
  Items = 'items',
  Stores = 'stores'
}

export type FetchFilterGroupsQueryVariables = Exact<{
  clientID: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
}>;


export type FetchFilterGroupsQuery = (
  { __typename?: 'Query' }
  & { fetchFilterGroups?: Maybe<Array<Maybe<(
    { __typename?: 'FilterGroup' }
    & Pick<FilterGroup, 'id' | 'context' | 'name' | 'created' | 'updated'>
    & { data: (
      { __typename?: 'GlobalFilter' }
      & Pick<GlobalFilter, 'accounts' | 'items' | 'stores' | 'states'>
    ) }
  )>>> }
);

export type FetchStoreItemGroupsQueryVariables = Exact<{
  clientID: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
}>;


export type FetchStoreItemGroupsQuery = (
  { __typename?: 'Query' }
  & { itemContext?: Maybe<Array<Maybe<(
    { __typename?: 'FilterGroup' }
    & Pick<FilterGroup, 'id' | 'context' | 'name' | 'created' | 'updated'>
    & { data: (
      { __typename?: 'GlobalFilter' }
      & Pick<GlobalFilter, 'accounts' | 'items' | 'stores' | 'states'>
    ) }
  )>>>, storeContext?: Maybe<Array<Maybe<(
    { __typename?: 'FilterGroup' }
    & Pick<FilterGroup, 'id' | 'context' | 'name' | 'created' | 'updated'>
    & { data: (
      { __typename?: 'GlobalFilter' }
      & Pick<GlobalFilter, 'accounts' | 'items' | 'stores' | 'states'>
    ) }
  )>>> }
);

export type FetchFilterGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FetchFilterGroupQuery = (
  { __typename?: 'Query' }
  & { fetchFilterGroup?: Maybe<(
    { __typename?: 'FilterGroup' }
    & Pick<FilterGroup, 'id' | 'context' | 'name'>
    & { data: (
      { __typename?: 'GlobalFilter' }
      & Pick<GlobalFilter, 'accounts' | 'items' | 'stores' | 'states'>
    ) }
  )> }
);

export type FetchFavoritesQueryVariables = Exact<{
  clientID: Scalars['String'];
  brandName?: Maybe<Scalars['String']>;
}>;


export type FetchFavoritesQuery = (
  { __typename?: 'Query' }
  & { fetchFavorites?: Maybe<Array<Maybe<(
    { __typename?: 'Favorite' }
    & Pick<Favorite, 'id' | 'context' | 'name' | 'url' | 'created' | 'deleted'>
    & { data: (
      { __typename?: 'GlobalFilter' }
      & Pick<GlobalFilter, 'accounts' | 'items' | 'stores' | 'states' | 'weeks' | 'endWeek' | 'brand'>
    ) }
  )>>> }
);

export type CreateFilterGroupMutationVariables = Exact<{
  clientID: Scalars['String'];
  input: CreateFilterGroupInput;
}>;


export type CreateFilterGroupMutation = (
  { __typename?: 'Mutation' }
  & { createFilterGroup?: Maybe<(
    { __typename?: 'FilterGroup' }
    & Pick<FilterGroup, 'id'>
  )> }
);

export type UpdateFilterGroupMutationVariables = Exact<{
  id: Scalars['ID'];
  clientID: Scalars['String'];
  input: CreateFilterGroupInput;
}>;


export type UpdateFilterGroupMutation = (
  { __typename?: 'Mutation' }
  & { updateFilterGroup?: Maybe<(
    { __typename?: 'FilterGroup' }
    & Pick<FilterGroup, 'id' | 'context' | 'name'>
    & { data: (
      { __typename?: 'GlobalFilter' }
      & Pick<GlobalFilter, 'accounts' | 'items' | 'stores' | 'states'>
    ) }
  )> }
);

export type DeleteFilterGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFilterGroupMutation = (
  { __typename?: 'Mutation' }
  & { deleteFilterGroup?: Maybe<(
    { __typename?: 'FilterGroup' }
    & Pick<FilterGroup, 'id' | 'context' | 'name'>
    & { data: (
      { __typename?: 'GlobalFilter' }
      & Pick<GlobalFilter, 'accounts' | 'items' | 'stores' | 'states'>
    ) }
  )> }
);

export type DeleteFavoriteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteFavoriteMutation = (
  { __typename?: 'Mutation' }
  & { deleteFavorite?: Maybe<(
    { __typename?: 'Favorite' }
    & Pick<Favorite, 'id' | 'context' | 'name' | 'url' | 'created' | 'deleted'>
    & { data: (
      { __typename?: 'GlobalFilter' }
      & Pick<GlobalFilter, 'accounts' | 'items' | 'stores' | 'states' | 'weeks' | 'endWeek' | 'brand'>
    ) }
  )> }
);


export const FetchFilterGroupsDocument = gql`
    query FetchFilterGroups($clientID: String!, $context: String, $search: String, $brand: String) {
  fetchFilterGroups(client: $clientID, context: $context, search: $search, brand: $brand) {
    id
    context
    name
    data {
      accounts
      items
      stores
      states
    }
    created
    updated
  }
}
    `;
export type FetchFilterGroupsQueryResult = Apollo.QueryResult<FetchFilterGroupsQuery, FetchFilterGroupsQueryVariables>;
export const FetchStoreItemGroupsDocument = gql`
    query FetchStoreItemGroups($clientID: String!, $search: String, $brand: String) {
  itemContext: fetchFilterGroups(client: $clientID, context: "signals-v2-item-group", search: $search, brand: $brand) {
    id
    context
    name
    data {
      accounts
      items
      stores
      states
    }
    created
    updated
  }
  storeContext: fetchFilterGroups(client: $clientID, context: "signals-v2-store-group", search: $search, brand: $brand) {
    id
    context
    name
    data {
      accounts
      items
      stores
      states
    }
    created
    updated
  }
}
    `;
export type FetchStoreItemGroupsQueryResult = Apollo.QueryResult<FetchStoreItemGroupsQuery, FetchStoreItemGroupsQueryVariables>;
export const FetchFilterGroupDocument = gql`
    query FetchFilterGroup($id: ID!) {
  fetchFilterGroup(id: $id) {
    id
    context
    name
    data {
      accounts
      items
      stores
      states
    }
  }
}
    `;
export type FetchFilterGroupQueryResult = Apollo.QueryResult<FetchFilterGroupQuery, FetchFilterGroupQueryVariables>;
export const FetchFavoritesDocument = gql`
    query FetchFavorites($clientID: String!, $brandName: String) {
  fetchFavorites(client: $clientID, brand: $brandName) {
    id
    context
    name
    data {
      accounts
      items
      stores
      states
      weeks
      endWeek
      brand
    }
    url
    created
    deleted
  }
}
    `;
export type FetchFavoritesQueryResult = Apollo.QueryResult<FetchFavoritesQuery, FetchFavoritesQueryVariables>;
export const CreateFilterGroupDocument = gql`
    mutation CreateFilterGroup($clientID: String!, $input: CreateFilterGroupInput!) {
  createFilterGroup(client: $clientID, input: $input) {
    id
  }
}
    `;
export type CreateFilterGroupMutationFn = Apollo.MutationFunction<CreateFilterGroupMutation, CreateFilterGroupMutationVariables>;
export type CreateFilterGroupMutationResult = Apollo.MutationResult<CreateFilterGroupMutation>;
export type CreateFilterGroupMutationOptions = Apollo.BaseMutationOptions<CreateFilterGroupMutation, CreateFilterGroupMutationVariables>;
export const UpdateFilterGroupDocument = gql`
    mutation UpdateFilterGroup($id: ID!, $clientID: String!, $input: CreateFilterGroupInput!) {
  updateFilterGroup(id: $id, client: $clientID, input: $input) {
    id
    context
    name
    data {
      accounts
      items
      stores
      states
    }
  }
}
    `;
export type UpdateFilterGroupMutationFn = Apollo.MutationFunction<UpdateFilterGroupMutation, UpdateFilterGroupMutationVariables>;
export type UpdateFilterGroupMutationResult = Apollo.MutationResult<UpdateFilterGroupMutation>;
export type UpdateFilterGroupMutationOptions = Apollo.BaseMutationOptions<UpdateFilterGroupMutation, UpdateFilterGroupMutationVariables>;
export const DeleteFilterGroupDocument = gql`
    mutation DeleteFilterGroup($id: ID!) {
  deleteFilterGroup(id: $id) {
    id
    context
    name
    data {
      accounts
      items
      stores
      states
    }
  }
}
    `;
export type DeleteFilterGroupMutationFn = Apollo.MutationFunction<DeleteFilterGroupMutation, DeleteFilterGroupMutationVariables>;
export type DeleteFilterGroupMutationResult = Apollo.MutationResult<DeleteFilterGroupMutation>;
export type DeleteFilterGroupMutationOptions = Apollo.BaseMutationOptions<DeleteFilterGroupMutation, DeleteFilterGroupMutationVariables>;
export const DeleteFavoriteDocument = gql`
    mutation DeleteFavorite($id: ID!) {
  deleteFavorite(id: $id) {
    id
    context
    name
    data {
      accounts
      items
      stores
      states
      weeks
      endWeek
      brand
    }
    url
    created
    deleted
  }
}
    `;
export type DeleteFavoriteMutationFn = Apollo.MutationFunction<DeleteFavoriteMutation, DeleteFavoriteMutationVariables>;
export type DeleteFavoriteMutationResult = Apollo.MutationResult<DeleteFavoriteMutation>;
export type DeleteFavoriteMutationOptions = Apollo.BaseMutationOptions<DeleteFavoriteMutation, DeleteFavoriteMutationVariables>;